export default __webpack_public_path__ + "static/media/PHP.6afc0acd.png";